<div class="flex-1 flex items-center justify-center relative min-h-0 h-full">
  <div class="h-0 w-0 overflow-hidden" [id]="'remote-stream'"></div>
  <div class="flex justify-center flex-col items-center h-full min-h-0 px-5">
    <div
      class="flex mb-7 items-center gap-1.5"
      [class.hidden]="callState() !== CALL_STATE.CONNECTED"
    >
      <app-icon name="call/lock-circle" [size]="20" svgClass="text-white" />
      <span class="text-white text-sm font-normal">Cuộc gọi mã hoá đầu cuối</span>
    </div>
    <div class="relative w-fit mb-8">
      <div class="custom-ring r1" [class.hidden]="!showSpeakingRing()"></div>
      <div class="custom-ring r2" [class.hidden]="!showSpeakingRing()"></div>

      @if (callState() === CALL_STATE.OUTGOING || callState() === CALL_STATE.CONNECTING) {
        <svg
          class="progress-svg absolute inset-0 w-full h-full -rotate-90 z-10"
          viewBox="0 0 80 80"
        >
          <circle cx="40" cy="40" r="38" stroke-width="4" class="stroke-transparent fill-none" />
          <circle
            cx="40"
            cy="40"
            r="38"
            stroke-width="4"
            class="stroke-white fill-none progress-circle"
            stroke-linecap="round"
          />
        </svg>
      }
      <app-avatar
        [id]="participant()?.userId || ''"
        [size]="150"
        [url]="participant()?.avatar || ''"
        [name]="participant()?.userName || ''"
        [isDevice]="isDevice()"
        [classes]="{ avatar: 'responsive-avatar' }"
      />
    </div>
    <div class="w-full flex flex-col items-center gap-2 px-6">
      @let oaInfo = linkedOaInfo();
      @if (!oaInfo && internetSource() && isFullscreen()) {
        <div class="bg-bg-badge-info rounded-3xl flex items-center py-1.5 px-6 gap-1.5">
          <app-icon name="call/home-wifi" [size]="20" svgClass="text-text-info-primary" />
          <span class="text-text-info-primary text-sm font-medium"
            >Khách hàng Internet Viettel</span
          >
        </div>
      }
      <div class="text-2xl text-white text-center font-semibold">
        {{ participant()?.userName || '' }}
      </div>
      @if (!oaInfo && internetSource() && address() && isFullscreen()) {
        <div class="flex items-center gap-2">
          <app-icon name="call/location" [size]="20" svgClass="text-white" />
          <p class="owner-name !text-white !text-base !font-normal">
            {{ address() }}
          </p>
        </div>
      }
      @if (oaInfo && isFullscreen()) {
        <div class="w-full flex flex-col gap-3 items-center">
          <div class="flex items-center gap-1 py-1.5 px-4 rounded-3xl bg-btn-glass">
            <span class="owner-name !text-white !text-base !font-normal" [title]="oaInfo?.oaName">
              {{ oaInfo?.oaName }}
            </span>
            <img class="flex-shrink-0" width="16" height="16" src="assets/images/oa.svg" alt="oa" />
          </div>
          @if (oaInfo.departmentName || oaInfo.positionName) {
            <p class="owner-name !text-white !text-base !font-normal">
              {{ oaInfo.departmentName }}
              @if (oaInfo.departmentName && oaInfo.positionName) {
                -
              }
              {{ oaInfo.positionName }}
            </p>
          }
        </div>
      }
      @if (isDevice()) {
        <app-tammi-device-badge variant="dark" class="w-fit" />
      }
      @if (
        callState() !== CALL_STATE.ENDED && callState() !== CALL_STATE.CONNECTED && hasCurrentCall()
      ) {
        <div class="text-white text-base font-normal typing">
          {{
            callType() === CALL_TYPE.VIDEO
              ? callState() === CALL_STATE.CONNECTING
                ? 'Đang nối máy đến người nhận'
                : 'Đang gọi video'
              : getCallStateText()
          }}
        </div>
      }
      @if (callState() === CALL_STATE.ENDED && hasCurrentCall()) {
        <div class="text-white text-base font-normal">
          {{ getEndReasonText() }}
        </div>
      }
      @if (callState() === CALL_STATE.CONNECTED && callType() === CALL_TYPE.AUDIO) {
        <div
          class="text-white text-base font-normal"
          [class]="{
            'text-text-warning-primary':
              isShowMyNetworkReconnecting() ||
              isShowRemoteNetworkWarning() ||
              isShowMyNetworkWarning(),
          }"
        >
          {{ callDuration() }}
        </div>
        @if (
          isShowMyNetworkReconnecting() || isShowRemoteNetworkWarning() || isShowMyNetworkWarning()
        ) {
          <div class="mt-6">
            <div class="flex flex-col items-center justify-center gap-4">
              <span class="animate-spin [animation-duration:2s]">
                <img
                  src="./assets/icon/call/loading-icon.svg"
                  alt="loading-icon"
                  height="32"
                  width="32"
                />
              </span>
              <p class="text-white text-center text-md typing">
                {{
                  isShowMyNetworkReconnecting()
                    ? 'Đang kết nối lại'
                    : 'Kết nối của ' +
                      networkQualityInfoName() +
                      ' không ổn định. Vui lòng chờ trong giây lát'
                }}
              </p>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
